import React from 'react';

/**
 * Side-by-side daily and monthly summary cards.
 */
function DailyMonthlySummary({ dailySummary, monthlyStats }) {
  if (!dailySummary && !monthlyStats) return null;

  return (
    <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '0.5rem', flexWrap: 'wrap' }}>
      {dailySummary && (
        <div style={{
          flex: '1',
          minWidth: '200px',
          padding: '0.5rem 0.75rem',
          backgroundColor: 'var(--card-bg)',
          border: '1px solid var(--border)',
          borderRadius: '4px',
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
        }}>
          <div style={{
            display: 'flex', alignItems: 'center', marginBottom: '0.35rem',
            paddingBottom: '0.3rem', borderBottom: '1px solid var(--border)'
          }}>
            <i className="fas fa-calendar-day" style={{ color: 'var(--primary)', fontSize: '0.75rem', marginRight: '0.5rem' }}></i>
            <h5 style={{ margin: 0, fontWeight: '600', color: 'var(--text)', fontSize: '0.8rem' }}>
              Podsumowanie Dzienne
            </h5>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.4rem' }}>
            <div style={{ textAlign: 'center', flex: 1 }}>
              <h3 style={{ margin: 0, fontSize: '0.8rem', fontWeight: '700', color: 'var(--success)' }}>
                {dailySummary.total_in?.toFixed(2) || '0.00'} zł
              </h3>
              <p style={{ margin: 0, fontSize: '0.65rem', color: 'var(--text-muted)' }}>Wpływy</p>
            </div>
            <div style={{ textAlign: 'center', flex: 1 }}>
              <h3 style={{ margin: 0, fontSize: '0.8rem', fontWeight: '700', color: 'var(--danger)' }}>
                {dailySummary.total_out?.toFixed(2) || '0.00'} zł
              </h3>
              <p style={{ margin: 0, fontSize: '0.65rem', color: 'var(--text-muted)' }}>Wydatki</p>
            </div>
          </div>
          <div style={{ textAlign: 'center', paddingTop: '0.4rem', borderTop: '1px solid var(--border)' }}>
            <h4 style={{
              margin: 0, fontSize: '0.75rem', fontWeight: '700',
              color: (dailySummary.balance || 0) >= 0 ? 'var(--success)' : 'var(--danger)'
            }}>
              {dailySummary.balance?.toFixed(2) || '0.00'} zł
            </h4>
            <p style={{ margin: 0, fontSize: '0.65rem', color: 'var(--text-muted)' }}>Bilans dnia</p>
          </div>
        </div>
      )}

      {monthlyStats && (
        <div style={{
          flex: '1',
          minWidth: '200px',
          padding: '0.5rem 0.75rem',
          backgroundColor: 'var(--card-bg)',
          border: '1px solid var(--border)',
          borderRadius: '4px',
          boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
        }}>
          <div style={{
            display: 'flex', alignItems: 'center', marginBottom: '0.35rem',
            paddingBottom: '0.3rem', borderBottom: '1px solid var(--border)'
          }}>
            <i className="fas fa-calendar-alt" style={{ color: 'var(--warning)', fontSize: '0.75rem', marginRight: '0.5rem' }}></i>
            <h5 style={{ margin: 0, fontWeight: '600', color: 'var(--text)', fontSize: '0.8rem' }}>
              Statystyki Miesięczne
            </h5>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.4rem' }}>
            <div style={{ textAlign: 'center', flex: 1 }}>
              <h3 style={{ margin: 0, fontSize: '0.8rem', fontWeight: '700', color: 'var(--info)' }}>
                {monthlyStats.total_transactions || 0}
              </h3>
              <p style={{ margin: 0, fontSize: '0.65rem', color: 'var(--text-muted)' }}>Transakcji</p>
            </div>
            <div style={{ textAlign: 'center', flex: 1 }}>
              <h3 style={{ margin: 0, fontSize: '0.8rem', fontWeight: '700', color: 'var(--success)' }}>
                {monthlyStats.total_amount?.toFixed(2) || '0.00'} zł
              </h3>
              <p style={{ margin: 0, fontSize: '0.65rem', color: 'var(--text-muted)' }}>Obrót</p>
            </div>
          </div>
          <div style={{ textAlign: 'center', paddingTop: '0.4rem', borderTop: '1px solid var(--border)' }}>
            <h4 style={{ margin: 0, fontSize: '0.75rem', fontWeight: '700', color: 'var(--info)' }}>
              {monthlyStats.avg_transaction?.toFixed(2) || '0.00'} zł
            </h4>
            <p style={{ margin: 0, fontSize: '0.65rem', color: 'var(--text-muted)' }}>Średnia transakcja</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default DailyMonthlySummary;
